<template>
  <tr>
    <th scope="row">{{displayName}}</th>
    <td v-for="(jour, index) of modele.jours" :key="index" :class="modele.jours[index][`${heure}s`]?'graybg':''">
      <select v-model="modele.jours[index][`${heure}`]" class="custom-select custom-select-sm">
        <option selected :value="null">-</option>
        <option :value="-1">QSP</option>
        <option
          v-for="employe of employes"
          :key="employe.id"
          :value="employe.id"
        >{{employe.acronyme}} - {{employe.nom}} {{employe.prenom}}</option>
      </select>
      <div class="custom-control custom-checkbox">
        <input type="checkbox" class="custom-control-input" :id="`${modele.jours[index].id}${heure}`" v-model="modele.jours[index][`${heure}s`]" />
        <label class="custom-control-label" :for="`${modele.jours[index].id}${heure}`">SiB</label>
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    heure: String,
    displayName: String,
    modele: Object,
    employesById: Array,
    employes: Array,
    list: Boolean
  }
};
</script>